import type { Options } from '@mui/material';
import { useMediaQuery, useTheme } from '@mui/material';
import { DeliveryProviderPortalService } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal';

export type DeviceType = DeliveryProviderPortalService.DeviceType;

const options: Options = {
  noSsr: true,
};

export function useIsMaxWidth(width: number) {
  return useMediaQuery(`(max-width: ${width}px)`, options);
}

export function useIsDesktop(): boolean {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.up('xl'), options);
}

export function useIsTabletOrLower(): boolean {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.down('md'), options);
}

export function useIsMobile(): boolean {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.down('xs'), options);
}

export function useDeviceType(): DeviceType {
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();

  if (isDesktop) {
    return DeliveryProviderPortalService.DeviceType.DESKTOP;
  }

  if (isMobile) {
    return DeliveryProviderPortalService.DeviceType.MOBILE;
  }

  return DeliveryProviderPortalService.DeviceType.TABLET;
}
